<template>
  <div class="login_page">
    <div class="login">
      <div class="logo">
        <img style="width: 100%" src="http://usdb.oss-us-west-1.aliyuncs.com/web_images/firmware-update/NEEWER@2x.png" alt="" />
      </div>
      <div class="login_title">纽尔蓝牙灯后台管理</div>
      <a-form-model
        class="login_form"
        ref="ruleForm"
        :rules="rules"
        :model="formData"
        @submit="goLogin"
      >
        <a-form-model-item prop="username">
          <a-input class="h40" v-model="formData.username" placeholder="请输入用户名" allow-clear>
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input-password
            class="h40"
            v-model="formData.password"
            type="password"
            placeholder="请输入密码"
            allow-clear
          >
            <a-icon slot="prefix" type="lock" />
          </a-input-password>
        </a-form-model-item>
        <div style="display: flex">
          <a-form-model-item prop="randCode">
            <a-input
              class="h40"
              :maxLength="4"
              v-model="formData.randCode"
              placeholder="验证码"
              allow-clear
            >
              <a-icon slot="prefix" type="safety" />
            </a-input>
          </a-form-model-item>
          <div
            style="width: 30%; height: 40px; text-align: center; line-height: 40px"
            @click="code"
          >
            <span v-if="!CodePic" style="font-size: 10px; color: #0082ff">{{ text }}</span>
            <img v-else :src="`data:image/png;base64,${CodePic}`" alt="验证码" />
          </div>
        </div>
        <a-form-model-item class="mb0">
          <a-button type="primary" html-type="submit" class="login_btn">登录</a-button>
          <a-tooltip placement="top">
            <template slot="title"><span>请联系管理员重置密码</span></template>
            <a-button type="link" class="login_remove">忘记密码</a-button>
          </a-tooltip>
          <div class="login_version">ver1.0.1</div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <p class="jszc"><a-icon type="desktop" />技术支持：深圳市纽尔科技有限公司</p>
  </div>
</template>

<script>
import { codeGet, login } from "@/api";
import { tips } from "@/utils/util";

export default {
  name: "Login",
  data() {
    let validateUsername = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    let randCode = (rule, value, callback) => {
      if (!value || value === "" || value.length !== 4) {
        callback(new Error("请输入正确得验证码"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        username: "",
        password: "",
        pwd: undefined,
        randCode: "",
      },
      rules: {
        username: [{ required: true, validator: validateUsername, trigger: "change" }],
        password: [{ required: true, validator: validatePassword, trigger: "change" }],
        randCode: [{ required: true, validator: randCode, trigger: "change" }],
      },
      text: "获取验证码",
      // 验证码
      CodePic: "",
      loading: false,
    };
  },
  created() {
    // if (localStorage.getItem("accessToken")) {
    //   this.$store.commit("UPDATE_USER_INFO", {
    //     nickname: "用户名",
    //     avatarUrl:
    //       "http://30days.oss-cn-shenzhen.aliyuncs.com/15191jo34g1582860508672.jpg",
    //     roleName: "后台管理员",
    //     rolePermissions:
    //       "OVERVIEW_DIAGRAM;ORDER_MANAGEMENT;ORDER_MANAGEMENT:ORDER_LIST;ORDER_MANAGEMENT:REFUND_LIST;LOGISTICS_TRACKING;LOGISTICS_TRACKING:LOGISTICS_MANAGEMENT;LOGISTICS_TRACKING:TRACKING_MANAGEMNET;SHIPPING_MANAGEMENT;SHIPPING_MANAGEMENT:HOME_LIST;SHIPPING_MANAGEMENT:STATION_LIST;COLLECTION_MANAGEMENT;COLLECTION_MANAGEMENT:COLLECTION_MANAGEMENT;ORDER_COMPLAIN;ORDER_COMPLAIN:ORDER_COMPLAIN_LIST;SYSTEM_MANAGEMENT;SYSTEM_MANAGEMENT:APP_UPGRADE;SYSTEM_MANAGEMENT:SYSTEM_LOG;SYSTEM_MANAGEMENT:ROLE_PERMISSION;SYSTEM_MANAGEMENT:USER_LIST;SYSTEM_MANAGEMENT:ADMIN_LIST;SYSTEM_MANAGEMENT:FEEDBACK",
    //   });
    //   this.$router.push("/home");
    // }
    this.code();
  },
  mounted() {
    // 微信扫码登录
    // var url = encodeURIComponent('http://project.30days-tech.com/')
    // var obj = new WxLogin({
    //     id: 'login_container',
    //     appid: 'wx8093eb47487d67ce',
    //     scope: 'snsapi_login',
    //     redirect_uri: url,
    //     state: Math.ceil(Math.random()*1000),
    //     style: "black",
    //     href: ''
    // })
  },
  methods: {
    goLogin(e) {
      // this.$router.push({
      //   name: "welcome"
      // });
      e.preventDefault();
      // this.formData.password = this.formData.pwd && md5(this.formData.pwd);
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid);
        if (!valid) return false;

        const password = md5(this.formData?.password);
        login({ ...this.formData, password })
          .then((res) => {
            const resultStatus = res?.resultStatus;
            if (!resultStatus) {
              // this.$message.error(res?.errorMessage || "网络异常");
              return false;
            }
            const { username, roleName, resources, accessToken } = res.resultData;
            if (accessToken) {
              try {
                sessionStorage.setItem("accessToken", accessToken);
                localStorage.setItem("accessToken",accessToken);
              } catch (e) {
                console.warn(e);
              }
            }
            this.$store.commit("UPDATE_USER_INFO", {
              username,
              roleName,
              rolePermissions: resources,
            });
            
            this.$router.push({
              name: "welcome",
            });
          })
          .catch((err) => {
            this.$message.error("登录失败");
          });
      });
    },
    code() {
      codeGet().then((res) => {
        if (this.loading) return false;
        if (!res) {
          tips(this, false, "获取验证码失败");
          return false;
        }
        this.CodePic = btoa(
          new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), "")
        );
      });
    },
    //   goLogin() {
    //     localStorage.setItem("accessToken", "1");
    //     this.$store.commit("UPDATE_USER_INFO", {
    //       nickname: "用户名",
    //       avatarUrl:
    //         "http://30days.oss-cn-shenzhen.aliyuncs.com/15191jo34g1582860508672.jpg",
    //       roleName: "后台管理员",
    //       rolePermissions:
    //         "OVERVIEW_DIAGRAM;ORDER_MANAGEMENT;ORDER_MANAGEMENT:ORDER_LIST;ORDER_MANAGEMENT:REFUND_LIST;LOGISTICS_TRACKING;LOGISTICS_TRACKING:LOGISTICS_MANAGEMENT;LOGISTICS_TRACKING:TRACKING_MANAGEMNET;SHIPPING_MANAGEMENT;SHIPPING_MANAGEMENT:HOME_LIST;SHIPPING_MANAGEMENT:STATION_LIST;COLLECTION_MANAGEMENT;COLLECTION_MANAGEMENT:COLLECTION_MANAGEMENT;ORDER_COMPLAIN;ORDER_COMPLAIN:ORDER_COMPLAIN_LIST;SYSTEM_MANAGEMENT;SYSTEM_MANAGEMENT:APP_UPGRADE;SYSTEM_MANAGEMENT:SYSTEM_LOG;SYSTEM_MANAGEMENT:ROLE_PERMISSION;SYSTEM_MANAGEMENT:USER_LIST;SYSTEM_MANAGEMENT:ADMIN_LIST;SYSTEM_MANAGEMENT:FEEDBACK",
    //     });
    //     this.$router.push("/home");
    //   },
  },
};
</script>

<style lang="less">
.h40 {
  input {
    height: 40px;
    line-height: 40px;
  }
}

.login_page {
  //width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  background: url("../../static/images/bg.png") no-repeat center/cover;
  //background-size: 100% 100%;

  .login {
    width: 432px;
    //height: 480px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    //top: 141px;
    top: 25%;
    right: 173px;
    margin-top: -100px;
    // color:;
    &_title {
      line-height: 33px;
      font-size: 24px;
      text-align: center;
      font-weight: 600;
      color: #333;
      margin-top: 17px;
      margin-bottom: 45px;
    }

    &_form {
      width: 280px;
      margin: 0 auto;
    }

    &_btn {
      width: 100%;
      background-color: #0082ff;
      border: none;
      height: 40px;
      line-height: 40px;
    }

    &_remove {
      //width: 64px;
      //height: 20px;
      font-size: 14px;
      cursor: pointer;
      color: #0082ff;
      display: block;
      margin: 0 auto;
      //margin-top: 15px;
      text-align: center;
    }

    &_version {
      //width: 47px;
      //height: 17px;
      font-size: 12px;
      color: #999999;
      text-align: center;
      margin-top: 60px;
      //position: absolute;
      //bottom: 20px;
      //left: 45%;
    }
  }

  .logo {
    width: 187px;
    height: 68px;
    margin: 0 auto;
    margin-top: 55px;
  }

  .ant-input {
    background: #f6f6f6;
    border: 1px solid #dddddd;
    border-radius: 3px;
  }
  .jszc {
    width: 100%;
    height: 17px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 17px;
    position: fixed;
    bottom: 15px;
    left: 0;
    .anticon {
      margin-right: 10px;
    }
  }
}

.mb0 {
  margin-bottom: 0;
}

.login_remove {
  span {
    vertical-align: text-bottom;
    margin-left: 3px !important;
    margin-top: 10px;
  }
}
</style>
